const navs = document.querySelectorAll('.wp-block-navigation');
navs.forEach((nav) => {
	const activeSubmenuItems = nav.querySelectorAll('.wp-block-navigation__submenu-container .current-menu-item');
	activeSubmenuItems.forEach((item) => {
		let parent = item.parentNode.closest('.wp-block-navigation-item.has-child');
		if( parent ) {
			parent.classList.add('current-menu-ancestor');
			let grandparent = parent.parentNode.closest('.wp-block-navigation-item.has-child')
			if( grandparent ) {
				grandparent.classList.add('current-menu-ancestor');
			}
		}
	})
});
